import { render, staticRenderFns } from "./UserAgencyCreate.vue?vue&type=template&id=08a1c652&"
import script from "./UserAgencyCreate.vue?vue&type=script&lang=js&"
export * from "./UserAgencyCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports